import { who_get_css_device } from "../general/helpers";

export default class SearchBlogFilter {

    constructor() {

        const search_filters = document.querySelector( '.blog-results-filters' ) ;
        if( search_filters == null ){ return ; }
        search_filters.addEventListener( 'click', (e ) => { this.search_posts_filter__handler( e ); } );

        // - - -  - - -  - - -  - - -  - - -

        const html = document.querySelector( 'html' ) ;
        html.addEventListener( 'click', (e ) => { this.search_jobs_filter__focusout( e ); } );

        // - - -  - - -  - - -  - - -  - - -

        // Resize : layout refresh
        this.layout_refresh() ;
    }

    search_posts_filter__handler( e ){

        // laisse passer les bouton si c'est pour le reset et les filtres
        // voir : search-form-posts.js ?

        let doStopPropagation = true ;

        let target_dataset = e.target.dataset ;
        if( ( typeof target_dataset.click != "undefined" ) && ( typeof target_dataset.behaviour != "undefined" ) ){

            // console.log( target_dataset ) ;

            if( ( 'search-form-posts-filter' === target_dataset.click ) && ( 'reset' === target_dataset.behaviour ) ){
                doStopPropagation = false ;
            }

            if( ( 'search-form-posts-refresh' === target_dataset.click ) && ( 'filter' === target_dataset.behaviour ) ){
                doStopPropagation = false ;
                this.close_aside_filter_panel();
            }

        }

        if( doStopPropagation ){ e.stopPropagation(); }


        // - - -

        let this_button = e.target.closest('button') ;

        if( this_button != null ){

            let btn_dataset = this_button.dataset ;

            if( 'search-blog-filter' === btn_dataset.click ){

                e.preventDefault();
                e.stopPropagation();

                // - -

                if( ( 'toggle-dropdown' === btn_dataset.behaviour ) ){

                    let the_filter = jQuery( this_button ).closest('.blog-results-filter') ;
                    jQuery('.blog-results-filter').not(the_filter).removeClass('is--filter-open');
                    the_filter.toggleClass('is--filter-open');
                }


                if( ( 'toggle-accordeon' === btn_dataset.behaviour ) ){

                    let the_filter = jQuery( this_button ).closest('.blog-results-filter') ;
                    the_filter.toggleClass('is--'+btn_dataset.target+'-control-open');

                }


                if( ( 'close-aside' === btn_dataset.behaviour ) ){

                    this.close_aside_filter_panel( this_button ) ;
                    /*
                    window.whodunit.theme.scrollBlock = false ;

                    let the_filter = jQuery( this_button ).closest('.blog-results-filters') ;
                    the_filter.removeClass('is--aside-open');
                    setTimeout(function(){ the_filter.removeClass('has--z-index--0'); }, 320);
                    */

                }


                if( ( 'open-aside' === btn_dataset.behaviour ) ){

                    window.whodunit.theme.scrollBlock = true ;

                    let body = jQuery( 'body' ) ;
                    body.addClass('is--filters-aside-open');

                    let the_filter = jQuery( this_button ).closest('.blog-results-filters') ;
                    the_filter.addClass('is--aside-open');
                    the_filter.addClass('has--z-index--1');

                }


            }


        }

        // -

    };



    // - - -  - - -  - - -  - - -  - - -


    close_aside_filter_panel( this_button = null ){

        let the_filter ;
        window.whodunit.theme.scrollBlock = false ;

        if( this_button == null ){
            the_filter = jQuery('.blog-results-filters') ;
        }else{
            the_filter = jQuery( this_button ).closest('.blog-results-filters') ;
        }

        the_filter.removeClass('is--aside-open');

        setTimeout(function(){
            the_filter.removeClass('has--z-index--0');

            let body = jQuery( 'body' ) ;
            body.removeClass('is--filters-aside-open');

        }, 320);

    }


    search_jobs_filter__focusout(){
        jQuery('.blog-results-filter').removeClass('is--filter-open');
    }


    // - - -  - - -  - - -  - - -  - - -

    // Resize : layout refresh
    layout_refresh(){

        let window__w = window.innerWidth ;
        let window__h = window.innerHeight ;

        jQuery( window ).on("debouncedresize", function (e){

            if( window__w === window.innerWidth ){ return; }
            window__w = window.innerWidth ;

            let device = who_get_css_device() ;

            if( ( device != 'mobile' ) && ( device != 'tablet' ) ){
                this.close_aside_filter_panel() ;
            }

        });
    }





}

